import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 24px;
`;

const ModalTitle = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin: 0 0 16px 0;
  text-align: center;
  font-weight: 600;
`;

const ModalMessage = styled.p`
  text-align: center;
  margin-bottom: 24px;
  color: #555;
  font-size: 14px;
  line-height: 1.6;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`;

const Button = styled.button<{ danger?: boolean }>`
  padding: 10px 20px;
  border: ${props => props.danger ? 'none' : '1px solid #E5E7EB'};
  border-radius: 6px;
  background-color: ${props => props.danger ? '#dc3545' : 'white'};
  color: ${props => props.danger ? 'white' : '#333'};
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  min-width: 100px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.danger ? '#c82333' : '#F9FAFB'};
  }
`;

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  invoiceNo: string;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  invoiceNo
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onCancel}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalTitle>Delete Invoice</ModalTitle>
        <ModalMessage>
          Are you sure you want to delete draft invoice <strong>{invoiceNo}</strong>? This action cannot be undone.
        </ModalMessage>
        <ButtonGroup>
          <Button onClick={onCancel}>Cancel</Button>
          <Button danger onClick={onConfirm}>Delete</Button>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DeleteConfirmationDialog;
